import { useAuthStore } from "../stores/authStore";
import { renewToken } from "../interface/token";
import { logout } from "../interface/user";

class TokenService {

    static isRefreshing = false;
    static refreshSubscribers: ((token: string) => void)[] = [];
  
    static subscribeTokenRefresh(cb: (token: string) => void) {
      this.refreshSubscribers.push(cb);
    }
  
    static onTokenRefreshed(token: string) {
      this.refreshSubscribers.forEach((cb) => cb(token));
      this.refreshSubscribers = [];
    }

    static async refreshToken() {
        const { refreshToken, clearAuth, setIdToken, setRefreshToken } = useAuthStore.getState();

        if (!refreshToken?.SS) {
            clearAuth();
            window.location.href = "/login";
            return null;
        }

        try {
            const response = await renewToken({
                refreshToken: refreshToken.SS,
            });
            const { idToken, refreshToken: newRefreshToken } = response.data.token;
            setIdToken(idToken);
            setRefreshToken(newRefreshToken);

            return idToken.SS;
        } catch (error) {
            clearAuth();
            window.location.href = "/login";
            return null;
        }
    }

    static async logout() {
        const { refreshToken, clearAuth } = useAuthStore.getState();

        if (!refreshToken?.ID) {
            clearAuth();
            window.location.href = "/";
            return null;
        }

        logout({
            tokenID: refreshToken.ID,
        }).then(response => {
            clearAuth();
            window.location.href = "/";
            return null;
        });
    }

}

export default TokenService;